import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom';
import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';
import gamerules from '../imagesHome/game-rules.png';
import typeaccount from '../imagesHome/game02.png';
import accountsplan from '../imagesHome/accountsplan.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import './CourseCarousel.css';

const listaCursuri = [
  {
    id: 1,
    titlu: 'Bazele contabilitatii',
    imagine: bazeleconta,
    culoare: 'card-curs-pp-bc',
    link: '/cursuri/bazele-contabilitatii'
  },
  {
    id: 2,
    titlu: 'Contabilitate financiara',
    imagine: contafinanciara,
    culoare: 'card-curs-pp-cf',
    link: '/cursuri/contabilitate-financiara'
  },
  {
    id: 3,
    titlu: 'Contabilitate de gestiune',
    imagine: gamerules,
    culoare: 'card-curs-pp-gr',
    link: '/cursuri/contabilitate-de-gestiune'
  },
  {
    id: 4,
    titlu: 'Contabilitate si raportari',
    imagine: typeaccount,
    culoare: 'card-curs-pp-ta',
    link: '/cursuri/contabilitate-si-raportari'
  },
  {
    id: 5,
    titlu: 'Contabilitate si fiscalitate',
    imagine: accountsplan,
    culoare: 'card-curs-pp-ap',
    link: '/cursuri/contabilitate-si-fiscalitate'
  },
];


const CursuriCarousel = () => {
 const elemente = listaCursuri.map((curs) => (
  <div className='background-lectii-carusel'>
    <Link
      to={curs.link} // ✅ folosim "to" pentru react-router
      key={curs.id}
      className={curs.culoare}
      
    >
      <img src={curs.imagine} alt={curs.titlu} />
      <span className='titlu-lectie-fp'>{curs.titlu}</span>
    </Link>

  </div>
  
));


  return (
    <div className="sectiune-cursuri-pp">
      <h2 className="titlu-cursuri-pp">Alege un curs</h2>
      <div className="container-cursuri-pp">
        <AliceCarousel
  items={elemente}
  infinite
  mouseTracking
  disableDotsControls
  controlsStrategy="responsive"
  touchMoveDefaultEvents={false}  // 👈 Asta oprește scrollul vertical
  responsive={{
    0: { items: 3 },
    768: { items: 3 },
    1024: { items: 3 }
  }}
  renderPrevButton={() => (
    <div className="sageata-cursuri-pp stanga-pp">
      <FontAwesomeIcon icon={faChevronLeft} className='size-first-page-arrows' />
    </div>
  )}
  renderNextButton={() => (
    <div className="sageata-cursuri-pp dreapta-pp">
      <FontAwesomeIcon icon={faChevronRight} className='size-first-page-arrows' />
    </div>
  )}
/>

      </div>
    </div>
  );
};

export default CursuriCarousel;
